import { render, staticRenderFns } from "./statusTag.vue?vue&type=template&id=7e909324&scoped=true&"
import script from "./statusTag.vue?vue&type=script&lang=js&"
export * from "./statusTag.vue?vue&type=script&lang=js&"
import style0 from "./statusTag.vue?vue&type=style&index=0&id=7e909324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e909324",
  null
  
)

export default component.exports